import { Single } from './Single';

const ReceiverPage = {
  Single,
};


export default ReceiverPage;